<div
  *ngFor="let item of productoList"
  class="dropcart__product"
  (window:resize)="onResize($event)"
>
  <div class="dropcart__product-image">
    <a [routerLink]="root.product(item.sku, item.name)">
      <img
        [src]="item.images['150'][0]"
        width="50px"
        height="50px"
        [alt]="item.name"
        onerror="this.onerror=null; this.src='/assets/img/no-image-ficha.jpg'"
      />
    </a>
  </div>
  <div class="dropcart__product-info dropcart__product-info-1 my-auto">
    <div class="dropcart__product-name">
      <a [routerLink]="root.product(item.sku, item.name)"
        >{{ item.name | capitalizeFirst }}
      </a>
    </div>

    <div class="dropcart__product-meta">
      <span class="dropcart__product-cant fw-bold"
        >{{ item.quantity }} X
      </span>
      <span class="dropcart__product-price" style="margin-left: 10px">{{
        item.price | currency
      }}</span>
    </div>
  </div>

  <div
    class="dropcart__product-info col-4 text-end py-0"
    [ngStyle]="{ 'font-size': innerWidth < 450 ? '14px' : '15px' }"
  >
    {{ item.price * item.quantity | currency }}
  </div>
</div>
